import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../hooks/redux';
import { getContacts } from '../../../utils';
import { ModalVariants } from '../../../models/Common';
import { modalSlice } from '../../../store/reducers/ModalSlice';
import { ReactComponent as EmailBWIcon } from '../../../assets/images/contacts/EmailBW.svg';
import { ReactComponent as EmailColoredIcon } from '../../../assets/images/contacts/EmailColored.svg';
import { ReactComponent as KyivstarBWIcon } from '../../../assets/images/contacts/KyivstarBW.svg';
import { ReactComponent as KyivstarColoredIcon } from '../../../assets/images/contacts/KiyivstarColored.svg';
import { ReactComponent as LifecellBWIcon } from '../../../assets/images/contacts/LifecellBW.svg';
import { ReactComponent as LifecellColoredIcon } from '../../../assets/images/contacts/LifecellColored.svg';
import { ReactComponent as PhoneBWIcon } from '../../../assets/images/contacts/PhoneBW.svg';
import { ReactComponent as PhoneColoredIcon } from '../../../assets/images/contacts/PhoneColored.svg';
import { ReactComponent as VodafoneBWIcon } from '../../../assets/images/contacts/VodafoneBW.svg';
import { ReactComponent as VodafoneColoredIcon } from '../../../assets/images/contacts/VodafoneColored.svg';
import { BasicButton } from '../buttons/BasicButton/BasicButton';

interface ContactsProps {
  isColored?: boolean;
}
const defaultProps = {
  isColored: false,
};

export const Contacts: FC<ContactsProps> = ({ isColored }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { openModal } = modalSlice.actions;
  const contacts = getContacts();

  const getIcon = (type: string) => {
    switch (type) {
      case 'email': {
        return isColored ? <EmailColoredIcon /> : <EmailBWIcon />;
      }
      case 'vodafone': {
        return isColored ? <VodafoneColoredIcon /> : <VodafoneBWIcon />;
      }
      case 'kyivstar': {
        return isColored ? <KyivstarColoredIcon /> : <KyivstarBWIcon />;
      }
      case 'lifecell': {
        return isColored ? <LifecellColoredIcon /> : <LifecellBWIcon />;
      }
      case 'phone': {
        return isColored ? <PhoneColoredIcon /> : <PhoneBWIcon />;
      }
      default: {
        return null;
      }
    }
  };

  const handleFeedback = () => {
    dispatch(openModal({ modalVariants: ModalVariants.AnonymousFeedback }));
  };

  return (
    <div className="contacts">
      <p className="contacts__title">{t('header.contacts')}</p>
      <div className="contacts__container">
        {contacts.map((el) => {
          return (
            <li key={el.contact}>
              {getIcon(el.type)}
              <a
                href={el.type === 'email' ? `mailto:${el.contact.trim()}` : `tel:${el.contact.trim()}`}
                target="_blank"
                rel="noreferrer"
              >
                {el.contact}
              </a>
            </li>
          );
        })}
        <li className="contacts__feedback">
          <BasicButton className="btn-feedback" handleClick={handleFeedback}>
            <span>{t('feedbackAndSuggestions.open')}</span>
          </BasicButton>
        </li>
      </div>
    </div>
  );
};
Contacts.defaultProps = defaultProps;
